// extracted by mini-css-extract-plugin
module.exports = {"button":"_a24c495"};